import * as React from "react";
const SvgIcEnter = props => <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="m16.26 12.167-5 5-1.183-1.184L13.068 13H3.76V3h1.667v8.333h7.641L10.077 8.35l1.183-1.183 5 5Z" /></svg>;
export default SvgIcEnter;